<template>
  <div
    class="mx-4 text-xs text-left grid grid-cols-11 border-b dark:bg-dark-800 dark:text-dark-text dark:border-dark-300 bg-white border-gray-300 text-gray-600"
    style="padding-left: 44px"
  >
    <div class="py-2 text-center" style="padding-left: 6px">
      {{ $t('message.policy') }}
    </div>
    <div class="py-2 px-2 text-center col-span-2">
      {{ $t('message.judgeId') }}
    </div>
    <div class="py-2 px-2 text-center col-span-2">
      {{ $t('message.user') }}
    </div>
    <div class="py-2 px-2 text-center col-span-2">
      {{ $t('message.rating') }}
    </div>
    <div class="py-2 px-2 text-center col-span-2"> Time</div>
    <div class="py-2 px-2 text-center col-span-2"> Code Size</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {}
  }
})
</script>

<style lang="postcss" scoped></style>
